import { render, staticRenderFns } from "./FolhaPagamentoLista.vue?vue&type=template&id=61f53923&scoped=true&"
import script from "./FolhaPagamentoLista.vue?vue&type=script&setup=true&lang=js&"
export * from "./FolhaPagamentoLista.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./FolhaPagamentoLista.vue?vue&type=style&index=0&id=61f53923&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f53923",
  null
  
)

export default component.exports